import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { start } from 'repl';

@Component({
  selector: 'app-people-strong-data-upload',
  templateUrl: './people-strong-data-upload.component.html',
  styleUrls: ['./people-strong-data-upload.component.css']
})
export class PeopleStrongDataUploadComponent implements OnInit {
  selectedFile: File | null = null;
  dateRange: { start: Date | null, end: Date | null } = { start: null, end: null };
  uploadSuccess: boolean | null = null;
  uploadError: string | null = null;
  fileTypeError: string | null = null;
  fileContent: any[] = [];
  private ApiUrl = environment.apiUrl;
  isUploadButtonDisabled: boolean = true;

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  // ngOnInit(): void {
  //   const today = new Date();
  //   const dayOfWeek = today.getDay();
  //   const startOfWeek = new Date(today);
  //   startOfWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
  //   const endOfWeek = new Date(startOfWeek);
  //   endOfWeek.setDate(startOfWeek.getDate() + 6);

  //     this.dateRange.start = startOfWeek; 
  //     this.dateRange.end = end;   
  //     this.updateUploadButtonState();
    
  // }
  ngOnInit(): void {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

      this.dateRange.start = startOfWeek; 
      this.dateRange.end = endOfWeek;   
      this.updateUploadButtonState();
    
  }



  triggerFileInput(): void {
    const fileInput = document.getElementById('file-upload') as HTMLInputElement | null;
    if (fileInput) {
      fileInput.click();
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.name.split('.').pop()?.toLowerCase();
      if (fileType === 'xls' || fileType === 'xlsx') {
        this.selectedFile = file;
        this.fileTypeError = null;
        this.readExcelFile(file);
        this.updateUploadButtonState();
      } else {
        this.selectedFile = null;
        this.toastr.error('Only Excel files (.xls, .xlsx) are allowed');
        this.updateUploadButtonState();
      }
    } else {
      this.selectedFile = null;
      this.updateUploadButtonState();
    }
  }

  readExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      this.fileContent = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    };
    reader.readAsArrayBuffer(file);
  }

  removeFile(): void {
    this.selectedFile = null;
    this.uploadSuccess = null;
    this.uploadError = null;
    this.fileTypeError = null;
    this.fileContent = [];
    this.updateUploadButtonState();
  }

  uploadFile(): void {
    console.log('Selected File:', this.selectedFile);
    console.log('Date Range Start:', this.dateRange.start);
    console.log('Date Range End:', this.dateRange.end);

    if (this.dateRange.start == null || this.dateRange.end == null) {
      this.toastr.error('Please select a valid date range.');
      return;
    }

    if (!this.selectedFile) {
      this.toastr.error('Please select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.http.post(this.ApiUrl + 'Timesheet/BulkUploadAttendanceData', formData, { responseType: 'text' }).subscribe(
      response => {
        this.toastr.success('Upload successful');
        this.uploadSuccess = true;
        this.uploadError = null;
        this.selectedFile = null;
        this.fileContent = [];
      },
      (error: HttpErrorResponse) => {
        console.error('Upload failed:', error);
        this.uploadSuccess = false;
        this.toastr.error('File upload failed. Please try again.');
      }
    );
    
  }
  

  onDateRangeChange(): void {
    this.updateUploadButtonState();
  }

  updateUploadButtonState(): void {
    this.isUploadButtonDisabled = !(this.selectedFile && this.dateRange.start && this.dateRange.end);
  }
}
